import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { nearestPlace } from "@/constants/places";

export function useRoute(points, steps = false) {
  const ok = points && points.length > 1 && points.every((p) => p && p.lat != null);
  const key = ok ? points.map((p) => `${p.lat.toFixed(3)},${p.lng.toFixed(3)}`).join("|") : "";
  const [route, setRoute] = useState(null);
  useEffect(() => {
    if (!key) {
      setRoute(null);
      return undefined;
    }
    let alive = true;
    api
      .post("/route", { points: points.map((p) => ({ lat: p.lat, lng: p.lng })), steps })
      .then((r) => {
        if (alive) setRoute(r.data);
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key, steps]);
  return route;
}

export async function labelFor(lat, lng) {
  try {
    const { data } = await api.get("/geo/reverse", { params: { lat, lng } });
    return data.address || nearestPlace(lat, lng);
  } catch {
    return nearestPlace(lat, lng);
  }
}

export const pomToday = () => new Date().toLocaleDateString("en-CA", { timeZone: "Pacific/Port_Moresby" });
